import _Vue from 'vue';
import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getInstance } from '../auth/authPlugin';

const blockbusterRequest = Axios.create({
  baseURL: process.env.VUE_APP_BLOCKBUSTER_ADDRESS,
});

blockbusterRequest.interceptors.request.use(async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const authService = getInstance();

  if (!authService.loading && authService.isAuthenticated) {
    const token = await authService.getTokenSilently({ audience: 'https://blockbuster.cam.simplisafe.com/' });

    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, error => Promise.reject(error));

export function getBlockbusterRequestInstance(): AxiosInstance {
  return blockbusterRequest;
}

export function AxiosBlockbusterPlugin(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$http = getBlockbusterRequestInstance();
}

const surelockRequest = Axios.create({
  baseURL: process.env.VUE_APP_SURELOCK_ADDRESS,
});

surelockRequest.interceptors.request.use(async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const authService = getInstance();

  if (!authService.loading && authService.isAuthenticated) {
    const token = await authService.getTokenSilently({ audience: 'https://surelock.cam.simplisafe.com/' });

    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, error => Promise.reject(error));

export function getSureLockRequestInstance(): AxiosInstance {
  return surelockRequest;
}

export function AxiosSurelockPlugin(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$http = getSureLockRequestInstance();
}
